/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseMCPListToolsFailedEvent = {
  type: "response.mcp_list_tools.failed";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
};

/** @internal */
export const ResponseMCPListToolsFailedEvent$inboundSchema: z.ZodType<
  ResponseMCPListToolsFailedEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.mcp_list_tools.failed"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseMCPListToolsFailedEvent$Outbound = {
  type: "response.mcp_list_tools.failed";
  sequence_number: number;
  item_id: string;
  output_index: number;
};

/** @internal */
export const ResponseMCPListToolsFailedEvent$outboundSchema: z.ZodType<
  ResponseMCPListToolsFailedEvent$Outbound,
  z.ZodTypeDef,
  ResponseMCPListToolsFailedEvent
> = z.object({
  type: z.literal("response.mcp_list_tools.failed"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseMCPListToolsFailedEventToJSON(
  responseMCPListToolsFailedEvent: ResponseMCPListToolsFailedEvent,
): string {
  return JSON.stringify(
    ResponseMCPListToolsFailedEvent$outboundSchema.parse(
      responseMCPListToolsFailedEvent,
    ),
  );
}
export function responseMCPListToolsFailedEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseMCPListToolsFailedEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseMCPListToolsFailedEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseMCPListToolsFailedEvent' from JSON`,
  );
}
